import React from "react";
import PropTypes from "prop-types";
import { ImageCard } from "../EngagementSectionV2/CompanyInitiative/styles";
import { connect } from "react-redux";
import { ImageUrl } from "../../utils/constants";
import { InitiativeDownloadIcon, CloseIconBranding, DownloadReportIcon } from "../../utils/icons";
import HoverButton from "../common/HoverButton";
import { ProgressBar } from "../HealthTabV2/HealthTabUpdated/styles";
import { fetchApi } from "../../utils/methods";
import { toast } from "react-toastify";
import { GetInitiativeDetailsById, GetInitiativeReport } from "../../redux/constants/apiConstants";
import { Border } from "../EventDetails/styles";
import CSVList from "../AttendeesModal/CSVList";
import moment from "moment";
import {HeaderPopup, StyledModal, StyledModalBody} from './styles'
// import SkeletonLoder from "../common/skeletonLoder";

class CompanyInitiative extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initiative: null,
      printCSV:false,
      isloading:false,
      initiativeReportData:[],
      headers:[
        { label: "First Name", key: "fname" },
        { label: "Last Name", key: "lname" },
        { label: "Email", key: "mail" },
        { label: "Completed On", key: "completed_on" },
      ]
    };
  }
  componentDidMount() {
    this.props.companyId && this.getInitiativeDetail();
  }

  getInitiativeDetail = async () => {
    try {
      const { companyId, detailInitiative, year } = this.props;
      const startDate = detailInitiative?.start_date
      const endDate = detailInitiative?.end_date;
      const postData = {
        company_id: companyId,
        // company_initiative_id: detailInitiative.company_initiative_id,
        initiative_id: detailInitiative.id,
        start_date: startDate,
        end_date: endDate,
      }; 
      if(year){
        postData.year=year
      }
      const res = await fetchApi(
        GetInitiativeDetailsById+"/"+companyId,
        "POST",
        postData,
        {},
        this.successFunc
      );
      if (res.message) {
        toast.error(res.message);
      }
      this.setState({ initiative: res.data[0] });
    } catch (error) {
      toast.error(error.message);
    }
  };

  getInitiativeReport = async () => {
    try {
      const { companyId, detailInitiative } = this.props;
      // const startDate = moment(detailInitiative?.start_date).format('YYYY-MM-DD');
      // const endDate = moment(detailInitiative?.end_date).format('YYYY-MM-DD');
      const res = await fetchApi(
        `${GetInitiativeReport}/${companyId}/${detailInitiative.company_initiative_id}`,
        "GET",
        null,
        {},
        this.successFunc
      );
      if (res.message) {
        toast.error(res.message);
      }
      this.setState({ initiativeReportData: res.data }, () => {
        this.setState({ printCSV: true });
      });
    } catch (error) {
      toast.error(error.message);
    }
  };
  showDetailInitiative = () => {
    const { initiative } = this.state;
    return (
      <React.Fragment>
        <div className="row-one">
          <div style={{ display: "flex" }}>
            <ImageCard bgColor={initiative?.color}>
              <img src={ImageUrl + "/" + initiative?.initiative_white_icon} />
            </ImageCard>
            <div className="details">
              <div>
                <span className="name">{initiative.initiative_name}</span>
              </div>
              <div style={{ marginTop: "10px" }}>
                <span className="points">
                  {initiative.is_upcoming ? "Upcoming" : "Active"} | +
                  {initiative.points} pts
                </span>
              </div>
            </div>
          </div>

          {!initiative.is_upcoming ? <div style={{ marginRight: "0px" }} onClick={()=>this.getInitiativeReport()}>
            <HoverButton
              width={"40px"}
              height={"40px"}
              title={"Download"}
              fillOpacity={1}
              disabled={false}
              backgroundColor={"#f0f6f8"}
              backgroundColorActive={"#005c87"}
              activeColor={"#007AB1"}
              inActiveColor={"white"}
              svgPath={<InitiativeDownloadIcon />}
            />
          </div>: null}
        </div>
        <div className="row-two">
          <div style={{display:"flex", alignItems:"center"}}>
            <span className="user-count" style={{color:initiative.font_color, fontSize: '24px', lineHeight: '24px', fontFamily: 'Rubik-Medium'}}>{initiative.initiative_count} Users</span> <span className="text" style={{ fontSize: '16px', lineHeight: "20px", color: '#005C8799', marginLeft:"12px" }}> completed out of {initiative.user_count}</span> <span className="user-count" style={{ color: 'rgba(0, 92, 135, 0.6)', fontFamily: 'rubik' }} /* style={{color:initiative.font_color}} */> </span> 
          </div>
          <div>
            <span className="percent" style={{color:initiative.font_color, fontSize: '24px', lineHeight: '24px', fontFamily: 'Rubik-Medium'}}>{initiative.percentage}%</span>
          </div>
        </div>
        <div
          className="row-three"
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <ProgressBar
              background={"#005C870D"}
              backgroundActive={initiative.color}
              width={initiative.percentage > 100 ? 100 : initiative.percentage}
              height={"20px"}
            >
              <div className="progress" style={{paddingRight:"20px",boxShadow:"unset"}}></div>
            </ProgressBar>
          </div>
        </div>
        <Border style={{background:'#005C871A',margin:'0px',width:"100%",marginTop:"20px"}}/>

        <div className="row-four" style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div className="other-detail" style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ marginBottom: '12px' }}><span className="title">Start Date</span></div>
            <div><span className="info">{ moment(new Date(initiative?.start_date)).format("MMM DD, YYYY") }</span></div>
          </div>

          <div className="other-detail" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <div style={{ marginBottom: '12px' }}><span className="title">End Date</span></div>
            <div><span className="info">
              {
                moment(new Date(initiative?.end_date)).format("MMM DD, YYYY")
              }
            </span></div>
          </div>
        </div>      
      </React.Fragment>
    );
  };

  downloadEnrolledList = (bool) => {
    this.setState({
      printCSV: bool,
      isloading: bool
    })
  };

  render() {
    const { showModal, onClose } = this.props;
    const {initiative} = this.state;
    window.console.log("testinggg showModal",showModal, initiative)
    return (
      initiative?.initiative_name&&<StyledModal
        transform={1}
        show={showModal}
        newWidth={"600px"}
        newBg={"newBg"}
        height="50px"
        display="none"
        onHide={() => onClose()}
      >
        <HeaderPopup>
          <div className="title">Initiative Info</div>
          <div className="closeIcon" onClick={() => onClose()}>
            {CloseIconBranding()}
          </div>
        </HeaderPopup>
        <div className="border-top"/>
        <StyledModalBody>
          <div className="popup-title">
            <ImageCard bgColor={initiative?.color}>
              <img src={ImageUrl + "/" + initiative?.initiative_white_icon} />
            </ImageCard>
            <div className="wrap">
              <div className="initiative">{initiative?.initiative_name}</div>
              <div className="active">
                {initiative?.is_upcoming ? "Upcoming" : "Active"} | +{initiative?.point_value} pts
              </div>
            </div>
            {!initiative?.is_upcoming ?<div className="download" onClick={()=>this.getInitiativeReport()}>
              {DownloadReportIcon()}
            </div>:null}
          </div>
          <div className="percentage-wrap">
            <div className="usercomplete">{initiative?.initiative_count} Users completed out of {initiative?.user_count}</div>
            <div className="percentage">{initiative?.percentage}%</div>
          </div>
          <div className="progress">
            <ProgressBar
              background={"#005C870D"}
              backgroundActive={initiative?.color}
              width={initiative?.percentage > 100 ? 100 : initiative?.percentage}
              height={"32px"}
            >
              <div className="progress-percentage"/>
            </ProgressBar>
          </div>
          <div className="border-line"/>
          <div className="date-wrap">
            <div className="first-date">
              <div className="date">Start Date</div>
              <div className="value">{moment(new Date(initiative?.start_date)).format("MMM DD, YYYY") }</div>
            </div>
            <div className="end-date">
              <div className="date">End Date</div>
              <div className="value">{moment(new Date(initiative?.end_date)).format("MMM DD, YYYY")}</div>
            </div>
          </div>
        </StyledModalBody>
        {this.state.printCSV &&
          <CSVList
            Title={`${this.state.initiative.initiative_name}_report`}
            removeCSVData={()=>this.setState({printCSV:false})}
            headers={this.state.headers}
            data={this.state.initiativeReportData}
          />
        }
      </StyledModal>
    );
  }
}
CompanyInitiative.propTypes = {
  showModal: PropTypes.bool.isRequired,
  companyPopup: PropTypes.func,
  onClose: PropTypes.func,
  detailInitiative: PropTypes.object,
  companyId: PropTypes.number,
  history: PropTypes.object,
  userId:PropTypes.number,
  setPage: PropTypes.func,
  year: PropTypes.number
};

const mapStateToProps = (state) => ({
  userId: state.profileData.userId,
})

export default connect(mapStateToProps, null)(CompanyInitiative);
